import { TelemetryConfigurator } from './TelemetryConfigurator.js';
import { TelemetryProvider } from './TelemetryProvider.js';
/**
 * Telemetry module definition for the Fusion Framework.
 *
 * @remarks
 * This module provides telemetry capabilities by configuring and initializing a telemetry provider.
 * It optionally integrates with the 'event' module if available.
 *
 * @type {TelemetryModule}
 *
 * @property {string} name - The name of the module ('telemetry').
 * @property {() => TelemetryConfigurator} configure - Factory function to create a new TelemetryConfigurator instance.
 * @property {(args) => Promise<ITelemetryProvider>} initialize - Asynchronous initializer that creates and returns a TelemetryProvider.
 *   - @param args - Initialization arguments, including configuration and module dependencies.
 *   - @returns A promise that resolves to an instance of ITelemetryProvider.
 */
export const module = {
    name: 'telemetry',
    configure: () => new TelemetryConfigurator(),
    initialize: async (args) => {
        const config = await args.config.createConfigAsync(args);
        const event = args.hasModule('event') ? await args.requireInstance('event') : undefined;
        const provider = new TelemetryProvider(config, { event });
        await provider.initialize({
            parent: config.parent,
            initialItems: config.items$,
        });
        return provider;
    },
};
export default module;
//# sourceMappingURL=module.js.map